module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('loading-bar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-729ec9f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Soc.vue
// module id = 506
// module chunks = 2